import { connect } from "react-redux";
import React, { useState } from "react";
import { InputNumber } from "antd";

import ConfirmButton from "../../../components/buttons/ConfirmButton";

import { setUserLimit } from "../../../modules/presence/api/api";

const UserLimitForm = ({
  getLimitsBonusesList,
  closeModal,
  token,
  user_id,
  limitsBonus = { monthly_limit: 0, quarterly_limit: 0 }
}) => {
  const [monthlyLimit, setMonthlyLimit] = useState(limitsBonus.monthly_limit || 0);
  const [quarterlyLimit, setQuarterlyLimit] = useState(limitsBonus.quarterly_limit || 0);

  const resetFields = () => {
    setMonthlyLimit(0);
    setQuarterlyLimit(0);
  };

  const handleDefineUserLimit = async () => {
    const dataToSend = {
      monthly_limit: monthlyLimit,
      quarterly_limit: quarterlyLimit,
      user_id
    };
    try {
      await setUserLimit(dataToSend, token);
      resetFields();
      getLimitsBonusesList();
      closeModal();
    } catch (e) {
      console.log("e", e, e.response);
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <div className="">Montant du plafond mensuel</div>
        <InputNumber
          style={{ backgroundColor: "#f0f0f0", borderRadius: "11px", borderColor: "#f0f0f0", width: "300px" }}
          min={0}
          value={monthlyLimit}
          onChange={setMonthlyLimit}
        />
      </div>
      <div className="flex justify-between items-center mb-4">
        <div className="">Montant du plafond trimestriel</div>
        <InputNumber
          style={{ backgroundColor: "#f0f0f0", borderRadius: "11px", borderColor: "#f0f0f0", width: "300px" }}
          min={0}
          value={quarterlyLimit}
          onChange={setQuarterlyLimit}
        />
      </div>
      <div className="pt-6 flex justify-center mt-6">
        <ConfirmButton label={"Appliquer"} large={true} onClick={handleDefineUserLimit} />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    token: state.auth.token
  };
};

export default connect(mapStateToProps)(UserLimitForm);



// WEBPACK FOOTER //
// src/containers/admin/premium/UserLimit.form.js